module.exports = __webpack_public_path__ + "img/moon.5f5e0610.png";